import { useFiatBalance } from 'hooks/wallets/useFiatBalance';
import { faFiatCurrencySymbols } from 'lib/fiat';

import type { Props as PaymentMethodIconProps } from '..';
import { PaymentMethodIcon } from '..';

type Props = Pick<PaymentMethodIconProps, 'size'>;

export const FiatWalletIcon = ({ size }: Props) => {
  const { fiatCurrency } = useFiatBalance();
  return (
    <PaymentMethodIcon
      size={size}
      backgroundColor="var(--c-onBase-success)"
      color="var(--c-white)"
      icon={faFiatCurrencySymbols[fiatCurrency]}
    />
  );
};
